import { makeAutoObservable, runInAction } from 'mobx';
import { request } from '@src/common';
import { HelperCore } from '@/common/helper';
import slsLogger from '@public/log/sls';
import userStore from '@/store/user';
import client from '@/store/client';
import globalStore from '@/store/global';
import clientStore from '@/store/client'

class Store {
  server_list = [];
  select_list = []; // 选择的工具列表
  chat_list = []; // 当前会话的工具列表
  showList = false;

  constructor() {
    makeAutoObservable(this);

    if (!HelperCore.IS_PROD) {
      window._ServerChoiceStore = this;
    }
  }

  checkServerChange() {
    return this.chat_list.sort().toString() !== this.select_list.sort().toString()
  }

  setServer = name => {
    const index = this.select_list.indexOf(name);
    if (index === -1) {
      this.select_list.push(name);
    } else {
      this.select_list.splice(index, 1);
    }
  };

  loadList = async type => {
    return await request
      .get('/ai_agent/mcp/list', {
        params: {
          t: +new Date,
          platform: HelperCore.getOsInfo()?.name,
          version: clientStore.version,
          is_client: clientStore.isLLQ ? 1 :0
        },
      })
      .then(res => {
        runInAction(() => {
          if (res?.data?.length) {
            this.server_list = res.data?.map(item => {
              return {
                icon: item.icon,
                is_local: item.is_local,
                server_id: item.server_id,
                server_name: item.server_name,
                display_name: item.display_name,
              }
            })
          }
        });
      })
      .catch(res => {
        if(!userStore.isUser){
          return;
        }

        slsLogger.log({
          key : "preview",
          action : "error_serverlist",
          ext2 : JSON.stringify(res),
        });
      })
      .finally(() => {
        //
      })
  };

  /**
   * 是否显示下拉列表
   */
  setShowList = async show => {
    if (show && userStore.isUser) {
      await this.loadList();
    }

    this.showList = show;
  };

  /**
   * 用于输入框会话参数
   */
  getMcpServeParams(asstId) {
    const list = globalStore.cloudConfig?.assistantLlmMcp?.roleids?.split(',');
    if (client.supportMcpAgent && this.select_list.length > 0 && list.includes(asstId)) {
      const local_mcp = [];
      const cloud_mcp = [];
      this.select_list.forEach(item => {
        const res = this.server_list.find(obj => obj.server_name === item);
        if (res) {
          if (res?.is_local === 1) {
            local_mcp.push(item)
          } else {
            cloud_mcp.push(item)
          }
        }
      })
      return {
        cloud_mcp,
        local_mcp,
      }
    }
    return {}
  }
}

const serverChoiceStore = new Store();
export default serverChoiceStore;
